import { render, staticRenderFns } from "./VideoPage.vue?vue&type=template&id=7fd90bbe&"
import script from "./VideoPage.vue?vue&type=script&lang=js&"
export * from "./VideoPage.vue?vue&type=script&lang=js&"
import style0 from "./VideoPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports